module.exports = {
    help: {
        pages: 3,
        pageNameFormat: "res/help/page_%d.jpg",
        priceFontName: "arial_bold_yelow_14",
        priceFontNameSecond: "arial_bold_14",
        click:"res/sounds/help/click",
        pricetable: [
            { // wild
                symbol: 0,
                wins: [5, 4, 3, 2],
                position: {x: 445 * 1.28, y: 89 * 1.28},
                offset: {width: 0, height: 17 * 1.28},
                align: 'center',
                offsetSecondX: 0
            },
            { // сумка с деньгами, мешок с деньгами
                symbol: 1,
                wins: [5, 4, 3, 2],
                position: {x: 595 * 1.28, y: 164 * 1.28},
                offset: {width: 0, height: 17 * 1.28},
                align: 'center',
                offsetSecondX: -60*1.28
            },
            { // монета, кошелек
                symbol: 3,
                wins: [5, 4, 3],
                position: {x: 200 * 1.28, y: 172 * 1.28},
                offset: {width: 0, height: 18 * 1.28},
                align: 'center',
                offsetSecondX: 60*1.28
            },
            { // стопка денег
                symbol: 5,
                wins: [5, 4, 3],
                position: {x: 625 * 1.28, y: 307 * 1.28},
                offset: {width: 0, height: 18 * 1.28},
                align: 'center',
                offsetSecondX: -60*1.28
            },
            { // А,К
                symbol: 6,
                wins: [5, 4, 3],
                position: {x: 184 * 1.28, y: 306 * 1.28},
                offset: {width: 0, height: 19 * 1.28},
                align: 'center',
                offsetSecondX: 60*1.28
            },
            { // Q,J,10
                symbol: 8,
                wins: [5, 4, 3],
                position: {x: 275 * 1.28, y: 415 * 1.28},
                offset: {width: 0, height: 19 * 1.28},
                align: 'center',
                offsetSecondX: 60*1.28
            },
            { // 9
                symbol: 11,
                wins: [5, 4, 3, 2],
                position: {x: 530 * 1.28, y: 407 * 1.28},
                offset: {width: 0, height: 17 * 1.28},
                align: 'center',
                offsetSecondX: -60*1.28
            },
            { // scatter
                symbol: 12,
                wins: [5, 4, 3, 2],
                position: {x: 445 * 1.28, y: 192 * 1.28},
                offset: {width: 0, height: 17.5 * 1.28},
                align: 'center',
                offsetSecondX: 0
            }

        ]
    }
};


//////////////////
// WEBPACK FOOTER
// ./cfg/help-config.js
// module id = 10
// module chunks = 0